import React, { Component } from 'react'
import YouTube from 'react-youtube';
import { Row, Col } from "react-bootstrap";

class Youtube extends Component {
    render() {
        const opts = {
            height: '400',
            width: '100%',
            playerVars: { // https://developers.google.com/youtube/player_parameters
              autoplay: 0,
              showinfo: 0
            },
            border: "1px 1px #44242"
        };

        return (
            <Row style={{paddingLeft: 20, paddingRight: 20, backgroundColor: "#f6f6f6", paddingBottom: 10,
                paddingTop: 10, borderTop:"1px solid #CCC", borderBottom: "1px solid #CCC"}}>
                <Col md= {6}>
                    <YouTube
                        videoId={this.props.videoId}
                        opts={opts}
                        onReady={this._onReady}
                    />
                </Col>
                <Col md= {6}>
                    <h4 className="fuente-monserrat custom-color"><strong>{(this.props.titulo).toUpperCase()}</strong></h4>
                    <div className="fuente-monserrat" align = "justify">{this.props.descripcion}</div>
                </Col>
            </Row>
        );
    }
}
 
export default Youtube;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Youtube.jsx